import {assert} from 'ts-essentials';
import {StaticConfig} from './types';

export function getStaticConfig(): StaticConfig {
  const staticConfig = window.__STATIC_CONFIG__;

  assert(
    staticConfig,
    "Expected static config to be available in the client's initial markup. " +
      'Make sure it is provided via the server rendering code and that it is valid JSON.',
  );

  return staticConfig;
}
